import React from 'react';
export const AnnouncementBar = () => {
  return <div className="w-full bg-medium h-[44px] flex items-center justify-center px-4" data-id="element-11">
      <p className="font-lato font-bold text-[14px] text-white tracking-[0.1em] text-center" data-id="element-12">
        LAUNCH PRICING: Complete bundle at $27 — moving to $47 soon
      </p>
    </div>;
};